export const getIP = async () => {
    try {
        const ipResponse = await fetch('https://ipinfo.io/json?token=3858d2d8d087f5');
        const ipData = await ipResponse.json();
        return ipData.ip;
    } catch (error) {
        return 111;
    }
}